// Init controller
var controller = new ScrollMagic.Controller({
    globalSceneOptions: {
        duration: $('section').height(),
        triggerHook: 1,
        reverse: true
    }
});

var scene1 = new ScrollMagic.Scene({triggerElement: '#section-01 .section__container'})
    .setClassToggle('#anchor1', 'active')
    .on("start", function (e) { $("#anchor2").toggleClass("inactive"); })
    .on("end", function (e) { $("#anchor2").toggleClass("inactive"); })
    .addTo(controller);
var scene2 = new ScrollMagic.Scene({triggerElement: '#section-02 .section__container'})
    .setClassToggle('#anchor2', 'active')
    .on("start", function (e) { $("#anchor3").toggleClass("inactive"); })
    .on("end", function (e) { $("#anchor3").toggleClass("inactive"); })
    .addTo(controller);
var scene3 = new ScrollMagic.Scene({triggerElement: '#section-03 .section__container'})
    .setClassToggle('#anchor3', 'active')
    .on("start", function (e) { $("#anchor4").toggleClass("inactive"); })
    .on("end", function (e) { $("#anchor4").toggleClass("inactive"); })
    .addTo(controller);
var scene4 = new ScrollMagic.Scene({triggerElement: '#section-04 .section__container'})
    .setClassToggle('#anchor4', 'active')
    .on("start", function (e) { $("#anchor5").toggleClass("inactive"); })
    .on("end", function (e) { $("#anchor5").toggleClass("inactive"); })
    .addTo(controller);
var scene5 = new ScrollMagic.Scene({triggerElement: '#section-05 .section__container'})
    .setClassToggle('#anchor5', 'active')
    .addTo(controller);

var controllerAnimate = new ScrollMagic.Controller();

$('.animate').each(function () {
    var scene = new ScrollMagic.Scene({
        triggerElement: this
    })
        .setClassToggle(this, 'active')
        .addTo(controllerAnimate);
});

controller.scrollTo(function (target) {

    TweenMax.to(window, 0.5, {
        scrollTo: {
            y: target,
            autoKill: true // Allow scroll position to change outside itself
        },
        ease: Cubic.easeInOut
    });

});


$(document).on('click', 'a[href^=\\#]', function (e) {
    var id = $(this).attr("href");

    if ($(id).length > 0) {
        e.preventDefault();

        controller.scrollTo(id);

        if (window.history && window.history.pushState) {
            history.pushState("", document.title, id);
        }
    }

});

$(window).scroll(function () {
    var intro = $('#section-01').height();
    var contentHeight = $('main').height();
    var menuHeight = $('.menu-scroll').height();

    var menuBottom = contentHeight - menuHeight;
    var menuBottomHide = intro - menuHeight - menuHeight / 2;

    if ($(window).scrollTop() >= menuBottom) {
        $('.menu-scroll').addClass('fixed');
    } else {
        $('.menu-scroll').removeClass('fixed');
    }

    if ($(window).scrollTop() >= menuBottomHide) {
        $('.menu-scroll__bottom').addClass('active');
    } else {
        $('.menu-scroll__bottom').removeClass('active');
    }
});

var lastScrollTop = 0;
$(window).scroll(function(event){
  var current = $(this).scrollTop();
  lastScrollTop = current;

  if (current <= lastScrollTop){
    $('header.header').addClass('show');
  }
  else {
    $('header.header').removeClass('show');
  }
});
